export default __webpack_public_path__ + "static/media/planet9.732d6053.webp";